import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { BlueBorderButtonBox } from '../../../component/buttons/CustomButtonBox';
import InputBox from '../../../component/InputBox';
import { actionFindId, actionReqPasswordReset } from '../../../module/body/main/FindIdPwModule';
import PopupRef from '../../../component/PopupRef';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import PropDescSelectionBox from '../../../component/PropDescSelectionBox';
import CodeUtil from '../../../util/CodeUtil';
import SelectionBox from '../../../component/SelectionBox';

const FindPwView = () => {
    const [authEmail, setAuthEmail] = useState('');
    const [authEmailUniversityCd, setAuthEmailUniversityCd] = useState(
        CodeUtil.getFirstCodePropDesc(CODE_GROUP_ID.USER_UNIVERSITY),
    );
    const [resetEmail, setResetEmail] = useState('');
    const [resetEmailUniversityCd, setResetEmailUniversityCd] = useState(
        CodeUtil.getFirstCodePropDesc(CODE_GROUP_ID.USER_UNIVERSITY),
    );
    const [universityCd, setUniversityCd] = useState(CodeUtil.getFirstCode(CODE_GROUP_ID.USER_UNIVERSITY));
    const [propDesc, setPropDesc] = useState(CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
    const [findIdPostAction, setFindIdPostAction] = useState(false);
    const [idNotExist, setIdNotExist] = useState(false);
    const [authFindIdResult, setAuthFindIdResult] = useState('');
    const [resetFindIdResult, setResetFindIdResult] = useState('');

    const { findPwResult } = useSelector((state) => state.findIdPwState);

    const popupRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        setIdNotExist(false);
    }, []);

    useEffect(() => {
        setAuthEmailUniversityCd(CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
        setResetEmailUniversityCd(CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
    }, [universityCd]);

    const onClickFindId = () => {
        if (NullCheckUtil.isEmpty(authEmail)) {
            popupRef.current.openAlert('메일 아이디를 입력해주세요.');
        } else if (authEmail.indexOf('@') > 0) {
            popupRef.current.openAlert('메일 아이디에 "@"가 포함 되어 있습니다. 아이디만 입력해 주세요.');
        } else {
            dispatch(
                actionFindId({
                    email: authEmail + '@' + authEmailUniversityCd,
                    callback: (findIdResult) => {
                        setAuthFindIdResult(findIdResult);
                    },
                }),
            );

            setFindIdPostAction(true);
        }
    };

    const onClickResetPw = () => {
        if (NullCheckUtil.isEmpty(resetEmail)) {
            popupRef.current.openAlert('메일 아이디를 입력해주세요.');
        } else if (resetEmail.indexOf('@') > 0) {
            popupRef.current.openAlert('메일 아이디에 "@"가 포함 되어 있습니다. 아이디만 입력해 주세요.');
        } else {
            const email = resetEmail + '@' + resetEmailUniversityCd;
            dispatch(
                actionFindId({
                    email,
                    callback: (findIdResult) => {
                        if (findIdResult) {
                            dispatch(
                                actionReqPasswordReset({
                                    data: { email, userId: email },
                                    callback: () => {
                                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                                            return function () {
                                                setIdNotExist(false);
                                            };
                                        });
                                    },
                                }),
                            );
                        } else {
                            setIdNotExist(true);
                        }
                    },
                }),
            );
        }
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='user-wrap'>
                    <div className='find-info-top'>
                        <h2 className='find-info-tit'>아이디 비밀번호 찾기</h2>
                    </div>
                    <div className='find-info-content'>
                        <SelectionBox
                            title='소속대학'
                            size='medium'
                            useAll={false}
                            value={universityCd}
                            options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                            onChange={(e) => setUniversityCd(e.target.value)}
                        />
                        <div className='find-info-box border-b'>
                            <h3 className='sub-tit'>아이디 찾기(가입여부 확인)</h3>
                            <p className='sub-comment'>
                                아이디는 학교 이메일로만 가입가능합니다. 학교 이메일을 입력하세요.
                            </p>
                            <div className='find-info-form'>
                                <InputBox
                                    value={authEmail}
                                    placeholder='이메일 ID를 입력하세요'
                                    onChange={(e) => setAuthEmail(e.target.value)}
                                />
                                <div className='mail-addr-delimeter'>@</div>
                                <InputBox
                                    value={authEmailUniversityCd}
                                    disabled={
                                        CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd) && true
                                    }
                                    onChange={(e) => setAuthEmailUniversityCd(e.target.value)}
                                    placeholder='이메일 주소를 입력하세요'
                                />
                                <div className='form-btn-box'>
                                    <BlueBorderButtonBox title='가입여부 확인' onClick={(e) => onClickFindId(e)} />
                                </div>
                            </div>
                            {findIdPostAction &&
                                (!authFindIdResult ? (
                                    <p className='find-red-txt'>아이디가 존재하지 않습니다. 회원가입이 필요합니다.</p>
                                ) : (
                                    <p className='find-red-txt'>해당 이메일은 가입되어 있습니다.</p>
                                ))}
                        </div>
                        <div className='find-info-box'>
                            <h3 className='sub-tit'>비밀번호 찾기(비밀번호 재설정)</h3>
                            <p className='sub-comment'>
                                아이디(학교 이메일)를 입력하세요.
                                <br />
                                등록된 이메일로 비밀번호 변경 메일이 발송되고, 해당 메일을 통해 비밀번호 변경이
                                가능합니다.
                            </p>
                            <div className='find-info-form'>
                                <InputBox
                                    value={resetEmail}
                                    placeholder='이메일 ID를 입력하세요'
                                    onChange={(e) => setResetEmail(e.target.value)}
                                />
                                <div className='mail-addr-delimeter'>@</div>
                                <InputBox
                                    value={resetEmailUniversityCd}
                                    disabled={
                                        CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd) && true
                                    }
                                    onChange={(e) => setResetEmailUniversityCd(e.target.value)}
                                    placeholder='이메일 주소를 입력하세요'
                                />
                                <div className='form-btn-box'>
                                    <BlueBorderButtonBox title='비밀번호 재설정' onClick={(e) => onClickResetPw(e)} />
                                </div>
                            </div>
                            {idNotExist ? (
                                <p className='find-red-txt'>해당 이메일로 가입된 정보가 없습니다.</p>
                            ) : (
                                findPwResult && (
                                    <p className='find-blue-txt'>
                                        메일이 발송되었습니다. 수신받은 메일을 이용하여 비밀번호 재설정을 진행하세요.
                                    </p>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default FindPwView;
